import PubSubJs from 'pubsub-js';

const register = (actionType, callback = () => {}) => {
    return PubSubJs.subscribe(actionType, (msg, data) => {
        callback(data)
    });
}

const unregister = (token) => {
    try{
        PubSubJs.unsubscribe(token);
    } catch (e) {
        /* eslint-disable no-console */
        console.log('Pubsub', e);
        /* eslint-enable no-console */
    }
}

const dispatch = (actionType, value = null) => {
    PubSubJs.publishSync(actionType, {actionType, value})
}

const PubSub = {
    register,
    unregister,
    dispatch,
}

export default PubSub;

const AppDispatcher = {
    dispatch: function () {
        /* eslint-disable no-undef */
        if(arguments.length > 1){
            PubSubJs.publishSync(arguments[0], arguments[1])
        } else {
            PubSubJs.publishSync('all', arguments[0])
        }
        /* eslint-enable no-undef */
    },
    unregister,
    register: function () {
        /* eslint-disable no-undef */
        if(arguments.length > 1){
            return PubSubJs.subscribe(arguments[0], (msg, data) => arguments[1](data));
        } else {
            return PubSubJs.subscribe('all', (msg, data) => arguments[0](data));
        }
        /* eslint-enable no-undef */
    }
}

export {
    AppDispatcher
}
